export default __webpack_public_path__ + "static/media/logoPng.6db0b7d6.svg";